import script from "./EntityDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityDashboard.vue?vue&type=script&setup=true&lang=js"

import "./EntityDashboard.vue?vue&type=style&index=0&id=96e167e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96e167e4"]])

export default __exports__